import { combineReducers } from "redux";
import { ACTION } from "./constants";

let initialState = { isLoading: false };

export default function StatutoryDisclosuresReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.STATUTORY_LIST:
            return { ...state, statutorydisclosureslist: action.data };
        case ACTION.GET_DESIGNATED_EMPLOYEE_DATA_NEW:
            return { ...state, designatedemployeeContent: action.data };
        case ACTION.STATUTORY_RISKOMETER:
            return { ...state, statutoryriskometer: action.data };
        case ACTION.STATUTORY_VALUATION:
            return { ...state, statutoryValuation: action.data };
        case ACTION.STATUTORY_SCHEME_FINANCE:
            return { ...state, statutorySchemeFinanceData: action.data };
        case ACTION.STATUTORY_COMMISSION:
            return { ...state, statutoryCommissionData: action.data };
        case ACTION.STATUTORY_AUM:
            return { ...state, statutoryAumData: action.data };
        case ACTION.STATUTORY_VOTING:
            return { ...state, statutoryVotingData: action.data };
        case ACTION.STATUTORY_ABRIDGED:
            return { ...state, statutoryAbriged: action.data };
        case ACTION.STATUTORY_ABRIDGE_FILLTER:
            return { ...state, statutoryReportFillter: action.data };
        case ACTION.STATUTORY_AVERAGE_PORTFOLIO:
            return { ...state, statutoryAveragePortfolio: action.data };
        case ACTION.MANDATORY_INVESTMENT:
            return { ...state, mandatoryInvestment: action.data };
        case ACTION.STATUTORY_MONTHS_FILLTER:
            return { ...state, statutoryMonthsFillter: action.data };
        case ACTION.STATUTORY_TRADE:
            return { ...state, statutoryTradeContent: action.data };
        case ACTION.STATUTORY_MONTH_YEAR_PORTFOLIO:
            return { ...state, monthPortfolioContent: action.data };
        case ACTION.STATUTORY_PORTFOLIO_MONTH:
            return { ...state, portFolioMonthList: action.data };
        case ACTION.STATUTORY_SEARCH:
            return { ...state, statutorySearch: action.data };
        case ACTION.STATUTORY_TRACKING_ERROR:
            return { ...state, trackingDifference: action.data };
        case ACTION.STATUTORY_ANNUAL_REPORT:
            return { ...state, annualReportContent: action.data };
        case ACTION.GET_TER_NEW_COMMON:
            return { ...state, terCommonContent: action.data };
        case ACTION.GET_TER_MONTH:
            return { ...state, terReportMonth: action.data };
        case ACTION.GET_TER_REPORT:
            return { ...state, ReportDataTer: action.data };
        case ACTION.GET_TER_NOTICE_CONTENT:
            return { ...state, terNoticeData: action.data };
        case ACTION.STATUTORY_STEWARDSHIP:
            return { ...state, stweardshipData: action.data };
        case ACTION.GET_REMUNERATION_CONTENT:
            return { ...state, remunerationData: action.data };
        case ACTION.STATUTORY_SCHEME_PERFORMANCE:
            return { ...state, schemePerformanceData: action.data };
        case ACTION.PUBLIC_CAUTION_NOTICE_NEW:
            return { ...state, publicCaution: { ...action.data, apiLoaded: true } };
        case ACTION.LETTER_UNIT_HOLDER:
            return { ...state, letterUnitData: action.data };
        case ACTION.SATURITY_COMPLAINTS:
            return { ...state, staComplaintData: action.data };
        case ACTION.STATUTORY_INVESTOR_COMPLAINTS:
            return { ...state, investorComplaintsData: action.data };
        case ACTION.STATUTORY_INVESTOR_COMPLAINTS_PMS:
            return { ...state, investorComplaintsPmsData: action.data };
        case ACTION.OFFER_DOCUMENTS:
            return { ...state, offerDocumentdataList: action.data };
        case ACTION.STATUTORY_RISK_DISCLOSURES:
            return { ...state, riskAdvisorydataList: action.data };
        case ACTION.DISTRIBUTOR_RELATED_EXPENSES:
            return { ...state, distributorRelatedList: action.data };
        case ACTION.MARKET_MAKER_PAGE:
            return {...state, marketmakersList: action.data};
        case ACTION.PASSIVE_FUND_ETF:
            return {...state, passiveFundList: action.data};
        case ACTION.STATUTORY_PASSIVE_FUND_MONTH:
            return {...state, passiveFundMonths: action.data};
        case ACTION.DAILY_PERFORMANCE_IR:
            return {...state, dailyPerfomanceIR: action.data};
        case ACTION.STATUTORY_REPORT_MISSELLING_FUND:
            return {...state, reportMissellingData: action.data};
        default:
            return state;
    }
}